import { useEffect, useState } from "react";
import { SubmitHandler } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import CreateBannerForm from "src/features/vendorSponsorshipAdmin/components/CreateBannerForm/CreateBannerForm";
import adaptEditFullpageTakeoverForm from "../../adapters/adaptEditFullpageTakeoverForm";
import adaptFullPageTakeoverForm from "../../adapters/adaptFullPageTakeoverForm";
import VENDOR_FULL_PAGE_TAKEOVER_FORM from "../../constants/vendorStepsForm";
import useActiveFullScreenTakeover from "../../hooks/useActiveFullScreenTakeover/useActiveFullScreenTakeover";
import useEditFullScreenTakeover from "../../hooks/useEditFullScreenTakeover/useEditFullScreenTakeover";

const EditFullScreenTakeover = () => {
	const navigate = useNavigate();
	const { formId } = useParams<{ formId: number }>();

	const [defaultValues, setDefaultValues] = useState<BannerFormState>({
		bannerStyle: "standard",
		bannerType: "fullScreenTakeoverBanner",
		selectedHashtag: null,
		steps: VENDOR_FULL_PAGE_TAKEOVER_FORM
	});

	const { data: banner } = useActiveFullScreenTakeover(formId);

	const { mutate: editForm } = useEditFullScreenTakeover();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Edited Successfully" />);
		navigate(
			"/vendor-sponsorship/full-screen-takeover/banners?published=false"
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="There is an error editing the form" />
		);
	};

	const onSubmit: SubmitHandler<BannerFormState> = (data) => {
		console.log("FORM IS VALID, EDIT FORM", { formId, data });

		editForm(adaptEditFullpageTakeoverForm(formId, data), {
			onSuccess,
			onError
		});
	};

	useEffect(() => {
		console.log({ banner, formId });

		if (formId && banner) {
			console.log("FETCH DEFAULT VALUES", {
				...defaultValues,
				bannerType: banner.template,
				steps: adaptFullPageTakeoverForm(banner)
			});

			setDefaultValues({
				...defaultValues,
				bannerType: banner.template,
				steps: adaptFullPageTakeoverForm(banner)
			});
		}
	}, [banner, formId]);

	return (
		<CreateBannerForm
			onSubmit={onSubmit}
			defaultValues={defaultValues}
			bannerTypeRadioOptions={["fullScreenTakeoverBanner"]}
			showBannerTypePicker={false}
			root="full-screen-takeover"
		/>
	);
};

export default EditFullScreenTakeover;
